<template>
  <div class="image-layer">
    <div class="bottom"></div>
    <div class="top"></div>
  </div>
</template>

<script>
export default{
  name: 'image-layer'
}
</script>

<style scoped lang="scss">
/** image-layer **/
@import '../../theme';

.top, .bottom {
  @include absolute-fill;
}
</style>
